"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
exports.File = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var button_1 = require("../button");
var Button_1 = __importDefault(require("remota-client/component/atoms/Button"));
var notification_1 = require("../../hook/notification");
var fat_1 = require("remota-common/util/fat");
var util_1 = require("remota-common/util");
exports.File = react_1.default.memo(function (props) {
    var icon = props.icon, useButton = props.useButton, label = props.label, accept = props.accept, disabled = props.disabled, multiple = props.multiple, numberOfMaximumFiles = props.numberOfMaximumFiles, lineHeight = props.lineHeight, action = __rest(props, ["icon", "useButton", "label", "accept", "disabled", "multiple", "numberOfMaximumFiles", "lineHeight"]);
    var notify = (0, notification_1.useNotify)();
    var errorMessage = (0, util_1.fat)("{{numberOfMaximumFiles}}件を超えるファイルはアップロードできません。");
    var handleChange = react_1.default.useCallback(function (ref, e) {
        var files = [].concat(Array.from(e.target.files || []));
        ref.current.value = null;
        if (!files) {
            return;
        }
        if (numberOfMaximumFiles && files.length > numberOfMaximumFiles) {
            notify({
                message: (0, fat_1.deFat)(errorMessage, function (msg) { return msg.replace("{{numberOfMaximumFiles}}", numberOfMaximumFiles.toString()); }),
                severity: "error",
            });
            return;
        }
        var _loop_1 = function (i) {
            var file = files[i];
            if ("onFile" in action) {
                action.onFile(file);
                return "continue";
            }
            var reader = new FileReader();
            if ("onArrayBuffer" in action) {
                reader.readAsArrayBuffer(file);
                reader.onload = function () {
                    if (reader.result !== null && typeof reader.result === "object") {
                        action.onArrayBuffer(reader.result, file);
                    }
                };
            }
            else if ("onBuffer" in action) {
                reader.readAsArrayBuffer(file);
                reader.onload = function () {
                    if (reader.result !== null && typeof reader.result === "object") {
                        action.onBuffer(Buffer.from(reader.result));
                    }
                };
            }
            else if ("onText" in action) {
                reader.readAsText(file, action.encoding || "utf8");
                reader.onload = function () {
                    if (typeof reader.result === "string") {
                        action.onText(reader.result);
                    }
                };
            }
        };
        for (var i = 0; i < files.length; i++) {
            _loop_1(i);
        }
    }, [action]);
    var ref = react_1.default.useRef(null);
    var handleClick = react_1.default.useCallback(function (e) {
        // e.preventDefault()
        // e.stopPropagation()
        // Reset the input value to allow the same file to be uploaded multiple times
        if (ref.current && ref.current.childNodes[0] && props.shouldResetOnClick) {
            var input = ref.current.childNodes[0];
            input.value = null;
        }
        ref.current && ref.current.click();
    }, [props.shouldResetOnClick]);
    var body = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Label, { ref: ref },
            react_1.default.createElement(Input, { type: "file", accept: accept, disabled: disabled, onChange: handleChange.bind(_this, ref), multiple: multiple, "data-testid": props.testId })),
        react_1.default.createElement(fat_1.Fat, { id: label })));
    if (props.inlineIcon) {
        return (react_1.default.createElement(button_1.NormalButton, { lineHeight: lineHeight, onClick: handleClick, disabled: disabled, "data-testid": "FileUpload" },
            props.inlineIcon,
            " ",
            body));
    }
    if (useButton) {
        return (react_1.default.createElement(Button_1.default, { icon: icon, color: "primary", disabled: disabled, "data-testid": "FileUpload", onClick: handleClick }, body));
    }
    return icon ? (react_1.default.createElement(button_1.IconButton, { icon: icon, onClick: handleClick, disabled: disabled, "data-testid": "FileUpload" }, body)) : (react_1.default.createElement(button_1.NormalButton, { disabled: disabled, onClick: handleClick, "data-testid": "FileUpload" }, body));
});
var Label = styled_components_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var Input = styled_components_1.default.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var templateObject_1, templateObject_2;
